import React, { useEffect } from "react";
import { Table, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getAsegoBookings, resetState } from "../features/AsegoBooking/AsegoBookingSlice";

const AsegoBookingList = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(resetState());
        dispatch(getAsegoBookings()); // Make sure this API returns Asego bookings
    }, [dispatch]);

    const bookingList = useSelector((state) => state.asegoBooking.AsegoBookings) || []; // Ensure this selector points to the correct state slice;

    console.log("Asego Bookings:", bookingList); // Debugging log

    // ---------------- Table Columns ----------------
    const columns = [
        {
            title: "S.No",
            dataIndex: "key",
            width: 70,
        },
        {
            title: "Customer Name",
            dataIndex: "name",
        },
        {
            title: "Email",
            dataIndex: "email",
        },
        {
            title: "Mobile",
            dataIndex: "mobile",
        },
        {
            title: "Passport",
            dataIndex: "passport",
        },
        {
            title: "Travel_Date",
            dataIndex: "travelDate",
        },
        {
            title: "Days",
            dataIndex: "days",
        },
        {
            title: "Amount",
            dataIndex: "amount",
        },
        {
            title: "Payment Status",
            dataIndex: "paymentStatus",
        },
        {
            title: "Order ID",
            dataIndex: "orderId",
        },
        {
            title: "Payment ID",
            dataIndex: "paymentId",
        },
        {
            title: "Reference",
            dataIndex: "reference",
        },
        {
            title: "API Status",
            dataIndex: "apiStatus",
        },
        {
            title: "Details",
            dataIndex: "errorCode",
        },
        {
            title: "Message",
            dataIndex: "message",
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
        },
    ];

    // ---------------- Data Mapping ----------------
    const dataSource = bookingList.map((item, index) => ({
        key: index + 1,

        // INSURED DETAILS
        name: item?.insured?.name || "—",
        email: item?.insured?.contactdetails?.emailaddress || "—",
        mobile: item?.insured?.contactdetails?.mobileno || "—",
        passport: item?.insured?.passport || "—",

        // TRAVEL DETAILS
        travelDate: item?.traveldetails ? `${item.traveldetails.departuredate} to ${item.traveldetails.arrivaldate}` : "—",
        days: item?.traveldetails?.days || "—",

        // PAYMENT DETAILS
        amount: `₹ ${item?.payment?.amountPaid || 0}`,

        paymentStatus:
            item?.payment?.status === "paid" ? (
                <Tag color="green">PAID</Tag>
            ) : item?.payment?.status === "pending" ? (
                <Tag color="orange">PENDING</Tag>
            ) : (
                <Tag>{item?.payment?.status || "N/A"}</Tag>
            ),

        orderId: item?.payment?.razorpayOrderId || "—",
        paymentId: item?.payment?.razorpayPaymentId || "—",

        // RESPONSE DETAILS
        reference:
            item?.response?.data?.reference?.trim() || "—",

        apiStatus: item?.response?.success ? (
            <Tag color="green">SUCCESS</Tag>
        ) : (
            <Tag color="red">FAILED</Tag>
        ),

        errorCode: item?.response?.success ? (
            <>
                <Tag color="green">Policy: {item.response.data.policyNumber}</Tag> <br /> <br />
                <Tag color="green"><a href={item.response.data.documentUrl} target="_blank" rel="noopener noreferrer">
                    View Document
                </a></Tag>
            </>
        ) : (
            <Tag color="red">Error: {item.response.errorCode}</Tag>
        ),

        message: item?.response?.message || "—",

        createdAt: item?.createdAt
            ? new Date(item.createdAt).toLocaleString()
            : "—",
    }));

    return (
        <div>
            <h3 className="mb-4 title">Asego Booking List</h3>

            <Table
                columns={columns}
                dataSource={dataSource}
                bordered
                pagination={{ pageSize: 10 }}
                scroll={{ x: 1500 }}
            />
        </div>
    );
};

export default AsegoBookingList;